<template>
  <div>
    <div v-if="isOverlayOpen" class="info-depracation__overlay" />
    <div class="info-depracation">
      <div class="container">
        <StoryblokComponent
          v-for="childBlok in props.blok.blocks"
          :key="childBlok._uid"
          :blok="childBlok"
        />
        <Translation
          scope="global"
          tag="p"
          class="info-depracation__message"
          keypath="common.sc_deprecated.message"
        >
          <span>
            {{ timeLeft }}
          </span>
        </Translation>
        <div class="info-depracation__buttons">
          <BaseButton
            :title="blok.link_label"
            class="info-depracation__link"
            :href="blok.link_url"
          >
            <template #text>
              {{ blok.link_label }}
            </template>
          </BaseButton>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { Translation } from 'vue-i18n'
import type { SbInfoDepracationSectionStoryblok } from '@/types'

interface Props {
  blok: SbInfoDepracationSectionStoryblok
}
const props = defineProps<Props>()
const timeLeft = ref(5)
const isOverlayOpen = ref(true)
let interval: NodeJS.Timeout | null = null

const scrollToTop = () => {
  window.scrollTo(0, 0)
}
const { cachedUrl } = useStoryblokLink(props.blok.link_url)

const startCountdown = () => {
  interval = setInterval(() => {
    if (timeLeft.value > 1) {
      timeLeft.value -= 1
    } else {
      clearInterval(interval!)
      navigateTo(cachedUrl.value)
    }
  }, 1000)
}

onMounted(() => {
  scrollToTop()
  startCountdown()
})

onUnmounted(() => {
  if (interval) clearInterval(interval)
})
</script>

<style lang="scss" scoped>
.info-depracation {
  background-color: var(--white);
  position: relative;
  padding: 80px 0;
  z-index: 9997;

  &__buttons {
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    @media (min-width: $breakpoint-md) {
      flex-direction: row;
    }
  }

  &__link {
    margin-bottom: 12px;

    @media (min-width: $breakpoint-md) {
      margin-right: 24px;
    }
  }

  &__overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: var(--gray-200);
    opacity: 0.7;
    z-index: 10;
  }
}
</style>
